export const SET_COMPANIES = 'setCompanies';
export const SET_FACETS = 'setFacets';
export const SET_PAGINATION = 'setPagination';
export const SET_SERVICE_REGIONS = 'setServiceRegions';
export const SET_LIABILITY_INSURANCES = 'setLiabilityinsurances';
export const SET_SITE_URL_SIGNUP = 'setSiteUrlSignup';
export const SET_SITE_URL_CONTACT = 'setSiteUrlContact';
export const SET_SITE_URL_ABOUT = 'setSiteUrlAbout';
export const SET_SEARCH_CRIETERIA = 'setsearchCrieteria';
